// https://vuex.vuejs.org/en/getters.html

export default {
  user: state => {
    return JSON.parse(localStorage.getItem("user"));
  },

  baseUrl: state => {
    return state.baseUrl;
  }
};
